import React from "react";
import Box from "@mui/material/Box";
import { s3baseUrl } from "src/config/config";
import { useChat } from "src/Hooks/ChatContext";
import ChatMessages from "./ChatMessages";
import { gr } from "src/design-system/tokens";
import icons from "src/design-system/icons";
import GrIcon from "src/design-system/components/GrIcon";
import GrIconButton from "src/design-system/components/GrIconButton";
import GrPresenceAvatar from "src/design-system/components/GrPresenceAvatar";
import { grCleanName } from "src/design-system/components/GrChatListRow";

const paneSx = {
  display: "flex",
  flexDirection: "column",
  minWidth: 0,
  minHeight: 0,
  height: "100%",
  // White conversation area: light bubbles with dark text read best on it (WhatsApp / Teams pattern).
  background: gr.color.surface,
  fontFamily: gr.font.family,
};

const headSx = {
  display: "flex",
  alignItems: "center",
  gap: gr.space[3],
  // Same height as the list header next to it (16 + 40 + 16), so the two dividers line up across the card.
  px: gr.space[4],
  py: gr.space[4],
  minHeight: `calc(${gr.control.md} + ${gr.space[4]} * 2)`,
  boxSizing: "border-box",
  background: gr.color.surface,
  borderBottom: `1px solid ${gr.color.line}`,
  flex: "none",
};

const nameSx = {
  m: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  fontSize: gr.font.size.lg,
  fontWeight: gr.font.weight.semibold,
  lineHeight: gr.font.lineHeight.tight,
  color: gr.color.ink,
  textTransform: "capitalize",
};

function ChatRight() {
  const { selectedChat, handleCloseChat, selectedChatUser } = useChat();
  const receiver_profile = selectedChatUser;

  return (
    <Box sx={paneSx}>
      {(selectedChat || receiver_profile) && (
        <Box sx={headSx}>
          {selectedChat && (
            <>
              <GrPresenceAvatar
                src={s3baseUrl + receiver_profile?.profileImage}
                name={grCleanName(receiver_profile?.name)}
                online={!!receiver_profile?.isOnline}
              />
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Box component="h2" sx={nameSx}>
                  {grCleanName(receiver_profile?.name)}
                </Box>
              </Box>
            </>
          )}
          {receiver_profile && (
            <GrIconButton
              variant="ghost"
              aria-label="Close conversation"
              onClick={handleCloseChat}
              sx={{ ml: "auto" }}
            >
              <GrIcon icon={icons.close} />
            </GrIconButton>
          )}
        </Box>
      )}
      <ChatMessages is_popup={false} />
    </Box>
  );
}

export default ChatRight;
